export default "__VITE_ASSET__4b81ceee__"